import {Card,CardActionArea,CardContent,Box,Typography,IconButton,Tooltip} from '@mui/material';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useNavigate} from 'react-router-dom';
import {adjustDateLocale} from '../../../../core/utilities/Utilities.js';
import MyAnalysisStatusChip,{resolveStatusCode} from './MyAnalysisStatusChip.js';

// Presentational card for one AnalysisRequest row, as returned by
// AnalysisRequest.get_list_formatted() (raw list projection - status is
// already the localized LOV label here, not the raw code, see
// MyAnalysisStatusChip.resolveStatusCode).
const MyAnalysisCard=({record,application})=>{
    const navigate=useNavigate();
    const statusCode=resolveStatusCode(record.status,application);
    // The published HTML report is viewable exactly when the request reached
    // COMPLETED (publish_analysis_report flips the request to COMPLETED).
    const canViewReport=statusCode==='COMPLETED';

    const handleOpen=()=>{
        navigate(`/my_analysis/${record.id}`);
    };

    const handleOpenReport=(event)=>{
        event.stopPropagation();
        navigate(`/my_analysis/${record.id}/report`);
    };

    return (
        // The "open report" control must NOT live inside CardActionArea below -
        // CardActionArea renders a real <button>, and nesting the IconButton's
        // own <button> inside it is invalid HTML (React warns "cannot be a
        // descendant of <button>" and hydration breaks). It's rendered as an
        // absolutely-positioned sibling instead, floated over the card's
        // top-right corner; CardContent gets extra right padding whenever it's
        // present so the in-flow chevron doesn't sit underneath it.
        <Card variant="outlined" sx={{borderRadius:3,position:'relative'}}>
            <CardActionArea onClick={handleOpen}>
                <CardContent sx={{pr:canViewReport?7:2}}>
                    <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:1}}>
                        <Box sx={{minWidth:0}}>
                            <Typography variant="caption" color="text.secondary" noWrap>
                                {adjustDateLocale(record.created_at)}
                            </Typography>
                            <Box sx={{mt:0.5}}>
                                <MyAnalysisStatusChip statusCode={statusCode} application={application} size="small"/>
                            </Box>
                        </Box>
                        <ChevronRightIcon aria-label={application.getLocale('ButtonViewDetails')} color="disabled"/>
                    </Box>
                </CardContent>
            </CardActionArea>
            {canViewReport&&(
                <Tooltip title={application.getLocale('ButtonViewReport')}>
                    <span style={{position:'absolute',top:'50%',right:8,transform:'translateY(-50%)'}}>
                        <IconButton color="primary" onClick={handleOpenReport}>
                            <SummarizeOutlinedIcon/>
                        </IconButton>
                    </span>
                </Tooltip>
            )}
        </Card>
    );
};

export default MyAnalysisCard;
